import { produce } from 'immer';
import { create } from 'zustand';
import { Chat01State, Chat01StoreState } from '~/types';

const useChat01Store = create<Chat01StoreState>((set) => ({
  showSendButton: false,
  showVideoCallModal: false,

  value: '',
  setValue: (newValue: string) =>
    set(
      produce((state: Chat01State) => {
        state.value = newValue;
      }),
    ),

  setShowSendButton: (showSendButton: boolean) => {
    set(
      produce((state: Chat01State) => {
        state.showSendButton = showSendButton;
      }),
    );
  },
  setShowVideoCallModal: (showVideoCallModal: boolean) => {
    set(
      produce((state: Chat01State) => {
        state.showVideoCallModal = showVideoCallModal;
      }),
    );
  },
}));

export default useChat01Store;
